var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('consulta-hc',{attrs:{"paciente":_vm.dp.pacienteId,"permiteAgrega":false,"permiteImprimir":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }